import { createSelector } from '@ngrx/store';
import { Prospect } from '@niko-crm/ui';
import { KanbanColumnState, prospectsKanbanFeature } from './prospect-kanban.reducer';

export const { selectProspectsKanbanState } = prospectsKanbanFeature;

export const selectKanbanColumns = createSelector(
  selectProspectsKanbanState,
  (state) => state.columns,
);

export const selectKanbanColumn = (stageId: string) =>
  createSelector(selectKanbanColumns, (columns): KanbanColumnState | undefined => columns[stageId]);

export const selectKanbanColumnItems = (stageId: string) =>
  createSelector(
    selectKanbanColumn(stageId),
    (column): Prospect[] => (column ? column.ids.map((id) => column.entities[id]) : []),
  );
